import { STRAPI_URL } from "../env";

export function downloadExcelExport(): boolean {
  try {
    window.open(`${STRAPI_URL}/excel-export`);
    return true;
  } catch (error) {
    console.error("Excel export failed:", error);
    return false;
  }
}

export function downloadProjectExcelExport(projectId: string): boolean {
  try {
    window.open(`${STRAPI_URL}/excel-export/${projectId}`);
    return true;
  } catch (error) {
    console.error("Excel export failed:", error);
    return false;
  }
}

export function downloadUsersExcelExport(): boolean {
  try {
    window.open(`${STRAPI_URL}/excel-export/users`);
    return true;
  } catch (error) {
    console.error("Excel export failed:", error);
    return false;
  }
}
